import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, inject, input, signal } from '@angular/core';
import { MainKpiConfig, MainKpiData } from '@uigy/modules/overview/kpis/kpi.interfaces';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { KpiMainComponent } from '@uigy/shared/components/widgets/kpi-main/kpi-main.component';
import Utils from '@uigy/utils';
import { LanguageService } from '@uigy/shared/services/language.service';

@Component({
    selector: 'app-ui-main-kpi-widget',
    imports: [
        AsyncPipe,
        KpiMainComponent
    ],
    templateUrl: './main-kpi-widget.component.html',
    styleUrl: './main-kpi-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainKpiWidgetComponent {
  public config = input.required<MainKpiConfig>();
  public isLoading = signal<boolean>(true);
  public data$?: Observable<MainKpiData>;
  protected readonly languageService = inject(LanguageService);
  protected readonly Utils = Utils;

  private cdr = inject(ChangeDetectorRef);

  constructor() {
    effect(() => {
      const config = this.config();
      if (config) {
        this.fetchKpiData();
      }
    }, {allowSignalWrites: true});
  }


  private fetchKpiData(): void {
    const config = this.config();

    this.setLoadingState(true);

    if (config.fetchData) {
      this.data$ = config.fetchData([config.filter, config.riskFilter]).pipe(
        tap(() => this.setLoadingState(false)),
      );
    } else {
      this.setLoadingState(false);
    }
  }

  private setLoadingState(state: boolean): void {
    this.isLoading.set(state);
    this.cdr.markForCheck();
  }
}
